import { render } from "./ProductPerformance.vue?vue&type=template&id=04e6d9fa&scoped=true"
import script from "./ProductPerformance.vue?vue&type=script&lang=js"
export * from "./ProductPerformance.vue?vue&type=script&lang=js"

import "./ProductPerformance.vue?vue&type=style&index=0&id=04e6d9fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e6d9fa"]])

export default __exports__